export default "__VITE_ASSET__CbOJYMon__"